<template>
  <Fragment>
    <div v-show="activeMicroApp" :id="microAppContainer" class="micro-app-container"></div>
    <div v-show="appStore.microAppLoading && activeMicroApp" v-loading="appStore.microAppLoading && activeMicroApp" class="micro-app-loading" :element-loading-text="$t('soda-b-web-i18n---加载中' /*加载中*/)" />
    <LoadAppError v-if="loadError" @reload="reload" />
  </Fragment>
</template>

<script>
import { useAppStore } from '@/store';
import { addMicroAppErrorHandler, microAppContainer, removeMicroAppErrorHandler } from '@/micro-app';
import { getJumpErrorPageCode } from '@/config/apps';
import { onUnmounted, ref } from 'vue';
import LoadAppError from '@/components/load-app-error';

export default {
  name: 'App',
  components: { LoadAppError },
  setup() {
    const loadError = ref(false);
    const appStore = useAppStore();
    const errorCodes = getJumpErrorPageCode();
    addMicroAppErrorHandler((e) => {
      console.error(e);
      appStore.setMicroAppLoadingStauts('loaded');
      loadError.value = errorCodes.some((errorCode) => {
        return e?.message?.includes(errorCode);
      });
    });
    onUnmounted(() => {
      removeMicroAppErrorHandler();
    });
    return {
      appStore: appStore.$state,
      microAppContainer,
      loadError,
      reload() {
        window.location.reload();
      },
    };
  },
  computed: {
    activeMicroApp() {
      return this.$route.path.includes('gtr_');
    },
  },
};
</script>

<style lang="scss" scoped>
.micro-app-container {
  margin: 0 20px;
  background-color: #fcfcfc;
  & > div {
    overflow: hidden;
  }
  .main-loading {
    display: none;
  }
}
// fix:侧边栏收起后loading布局不全覆盖
.micro-app-loading {
  position: absolute;
  background: #f8f8fa;
  z-index: 9;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
</style>
